import React, { useState } from 'react';
import { Wrapper, Svg } from '../basic';
import { LocalizeButton } from './Button';
export const HelpIcon = ({ iconSize }) => {
    return (React.createElement("span", { className: `tb-icon ${iconSize ? `tb-icon-${iconSize}` : ''}` },
        React.createElement(Svg, { path: "icon-help" })));
};
export const HelpText = ({ help, iconSize, wrapper, className, children }) => {
    const [showHelp, setShowHelp] = useState(false);
    const onClick = (e) => {
        e.preventDefault();
        setShowHelp(!showHelp);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { element: wrapper || 'p', className: className },
            children,
            ' ',
            React.createElement(LocalizeButton, { type: "info", onClick: onClick },
                React.createElement(HelpIcon, { iconSize: iconSize }))),
        showHelp && (React.createElement(Wrapper, { element: "p", className: "txt-sm" },
            React.createElement(HelpIcon, null),
            " ",
            help))));
};
//# sourceMappingURL=HelpText.js.map